import React from "react";
import { Page, View, Text, Image, StyleSheet } from "@react-pdf/renderer";
import { PDF_PAGE } from "../../constants/pdfSizes";
import defaultBg from "../../assets/policy.jpg";
import hotelIcon from "../../assets/hotelIcon.png";
import paymentIcon from "../../assets/paymentIcon.png";
import gradientOverlay from "../../assets/policyCover.png";

const styles = StyleSheet.create({
  page: {
    width: PDF_PAGE.width,
    height: PDF_PAGE.height,
    position: "relative",
    backgroundColor: "#000",
  },
  background: {
    position: "absolute",
    width: "100%",
    height: "100%",
    objectFit: "cover",
  },
  overlay: {
    position: "absolute",
    top: 0,
    left: 0,
    width: PDF_PAGE.width,
    height: PDF_PAGE.height,
    opacity: 1,
    objectFit: "cover",
  },
  container: {
    paddingTop: 10,
    flexDirection: "column",
    alignItems: "center",
    width: "100%",
  },
  icon: {
    width: 57,
    height: 57,
    marginBottom: 4,
  },
  title: {
    fontFamily: "Montserrat",
    fontSize: 44,
    textAlign: "center",
    color: "#fff",
    fontWeight: "medium",
    marginBottom: 0,
  },
  subtitle: {
    fontFamily: "Montserrat",
    fontSize: 20,
    textAlign: "center",
    color: "#fff",
    marginBottom: 10,
  },
  optionBox: {
    marginVertical: 12,
    borderWidth: 1,
    borderColor: "#4F6295",
    paddingBottom: 8,
    paddingHorizontal: 20,
    width: "96%",
    backgroundColor: "transparent",
  },
  optionLabel: {
    backgroundColor: "#fff",
    borderRadius: 6,
    paddingVertical: 6,
    paddingHorizontal: 14,
    alignSelf: "center",
    marginTop: -14,
    marginBottom: 12,
    borderWidth: 1,
    borderColor: "#987328",
  },
  optionLabelText: {
    fontSize: 13,
    fontWeight: "bold",
    fontFamily: "Montserrat",
    color: "#090F49",
    textAlign: "center",
  },
  tableHeader: {
    flexDirection: "row",
    borderBottomWidth: 1,
    borderColor: "#987328",
    paddingVertical: 6,
    paddingHorizontal: 6,
  },
  tableRow: {
    flexDirection: "column",
    paddingVertical: 3,
    paddingHorizontal: 4,
  },
  colHeader: {
    flex: 1,
    textAlign: "left",
    fontSize: 12,
    fontWeight: "semibold",
    color: "#fff",
    fontFamily: "Montserrat",
    paddingVertical: 0,
    paddingHorizontal: 0,
  },
  col: {
    flex: 1,
    textAlign: "center",
    fontSize: 12,
    color: "#fff",
    fontFamily: "Montserrat",
    fontWeight: "medium",
  },
  innerHeading: {
    color: "white",
    fontFamily: "Montserrat",
    fontWeight: 700,
    fontSize: 14,
    marginBottom: 4,
  },
  description: {
    color: "white",
    fontSize: 14,
    fontFamily: "Montserrat",
    marginBottom: 8,
  },
  bullet: {
    fontSize: 18,
    color: "#fff",
    marginRight: 10,
    marginTop: -2,
    textShadow: "1px 1px 2px #000",
  },
  listText: {
    fontSize: 16,
    color: "#fff",
    fontFamily: "Montserrat",
    lineHeight: 1.4,
    flex: 1,
    fontWeight: "medium",
    textShadow: "0px 0px 10px #000", 
  },
  listItem: {
    flexDirection: "row",
    alignItems: "center",
    marginBottom: 2,
  },
});

const PaymentTermsPolicySlide = ({
  bg,
  icon = paymentIcon,
  heading = "Payment TERMS & POLICY",
  tagline = "",
  policyGroups = [],
}) => {
  const defaultBgImage = bg || defaultBg;
  return (
    <Page size={PDF_PAGE} style={styles.page}>
      <Image src={defaultBgImage} style={styles.background} />
      <Image src={gradientOverlay} style={styles.overlay} />

      <View style={styles.container}>
        {icon && <Image src={icon} style={styles.icon} />}
        <Text style={styles.title}>{heading}</Text>
        <Text style={styles.subtitle}>{tagline}</Text>

        {policyGroups.length === 0 ? (
          <Text style={styles.subtitle}>No hotel options available</Text>
        ) : (
          policyGroups.map((group, i) => (
            <View key={i} style={styles.optionBox}>
              <View style={styles.optionLabel}>
                <Text style={styles.optionLabelText}>
                  {group.groupName || `HOTEL OPTION ${i + 1}`}
                </Text>
              </View>

              <View style={{ marginTop: 10 }}>
                {Array.isArray(group.detail) && group.detail.length > 0 ? (
                  group.detail.map((item, idx) => {
                    if (typeof item === "string") {
                      return (
                        <View key={idx} style={styles.tableRow}>
                        
                          <View style={styles.listItem} key={idx}>
                            <Text style={styles.bullet}>•</Text>
                            <Text style={styles.listText}>{item}</Text>
                          </View>
                        </View>
                      );
                    }

                    return (
                      <View key={idx} style={styles.tableRow}>
                        <Text
                          style={[styles.innerHeading, { textAlign: "left" }]}
                        >
                          {item.heading || "--"}
                        </Text>
                        <Text
                          style={[styles.description, { textAlign: "left" }]}
                        >
                          {item.description || "--"}
                        </Text>
                      </View>
                    );
                  })
                ) : (
                  <Text style={styles.noDataText}>
                    No terms available for this section
                  </Text>
                )}
              </View>
            </View>
          ))
        )}
      </View>
    </Page>
  );
};

export default PaymentTermsPolicySlide;
